class ListaDocumentosActionTypes {
  constructor() {
    this.UPDATE = 'UPDATE';
    this.EDIT = 'EDIT';
    this.LOADING = 'LOADING';
    this.REMOVE = 'REMOVE';
    this.ADD = 'ADD';
  }
}

export default new ListaDocumentosActionTypes();
